import TidyOptBar from 'components/dot/bar/tidy-opt-bar';
import { CellTidyDataType } from 'components/item/cell-tidy';
import CellTidyList from 'components/list/cell-tidy-list';
import { useEffect, useRef, useState } from 'react';

import { Toast } from 'antd-mobile';
import { VideoListType } from 'app/constant';
import NoDataTip from 'components/dot/no-data-tip';
import { useI18n } from 'i18n/useI18n';
import { useDispatch, useSelector } from 'react-redux';
import { VideoDataType } from 'services/apis/cnt/video-api';
import VideoListApi from 'services/apis/usr/video-list-api';
import { bizBaseUrl } from 'services/request';
import { setList } from 'stores/collectSlice';
import { scrollTop } from 'utils/screenUtil';

export default function UserCollect(props: { collectListId: string }) {
  const { t } = useI18n();
  const [tidyStatus, handleTidyStatus] = useState(false);

  const collectList = useSelector((state: any) => state.collectListHandle.value);
  const dispatch = useDispatch();

  const ignore = useRef<boolean>(false);
  const [pageInfo, setPageInfo] = useState({ current: 1, pageSize: 12 });
  const [page, setPage] = useState<{ start: number; end: number }>({
    start: pageInfo.current - 1,
    end: pageInfo.pageSize,
  });

  const fetchList = async (listId: string) => {
    const result = await VideoListApi.listWithType(listId, []);
    if (result.code === 0 && result.successful) {
      // console.log("dataList", result.result);
      let dataList: CellTidyDataType[] = [];
      (result.result as VideoDataType[])?.forEach(async (item, index) => {
        dataList.push({
          postUuid: item.postUuid,
          postTitle: item.postTitle,
          postCover: item.postCoverUrl?.replaceAll('\\', '/').replaceAll('D:/_Resource/', bizBaseUrl + '/images/'),
          postSourceType: item.postSourceType,
          termUuid: item.termUuid,
          isCollect: true,
          isRemove: false,
          showMask: false,
          handleRemove: () => {},
        } as CellTidyDataType);
      });
      console.log('dataList', result.result, dataList);
      dispatch(setList(dataList));
      // console.log("user", user);
      // console.log("dataList", dataList);
    } else {
      Toast.show(t('collect.index.863806-0'));
    }
  };

  useEffect(() => {
    if (props.collectListId) {
      fetchList(props.collectListId);
    }
  }, [props.collectListId]);

  return (
    <div className=" mt-2">
      <TidyOptBar
        name={t('collect.index.863806-1')}
        tidyStatus={tidyStatus}
        handleStatus={handleTidyStatus}
        videoListId={props.collectListId}
        videoListType={'collect'}
      />
      {collectList.length === 0 ? (
        <NoDataTip />
      ) : (
        <>
          <div className=" mt-2">
            <CellTidyList
              column={3}
              tidyStatus={tidyStatus} //0 关闭整理 1 开启整理 显示遮罩
              handleTidyStatus={handleTidyStatus}
              cellTidyList={collectList}
            />
          </div>
        </>
      )}
    </div>
  );
}
